import React, { useState } from "react";
import {
  Box,
  Typography,
  Switch,
  Divider,
  Avatar,
  Button,
  Paper,
} from "@mui/material";
import Form from "react-bootstrap/Form"; // ✅ Required for Form.Check

const PrivacyVisiblity = () => {
  const [collabAvailable, setCollabAvailable] = useState(false);
  const [pastCollabVisible, setPastCollabVisible] = useState(true);

  const [blockedUsers, setBlockedUsers] = useState([
    { id: 1, name: "Jon Doe", category: "Fashion" },
    { id: 2, name: "Jon Doe", category: "Fashion" },
    { id: 3, name: "Jon Doe", category: "Fashion" },
    { id: 4, name: "Jon Doe", category: "Fashion" },
    { id: 5, name: "Jon Doe", category: "Fashion" },
  ]);

  const handleUnblock = (id) => {
    setBlockedUsers((prev) => prev.filter((user) => user.id !== id));
  };

  return (
    <Box
      p={3}
      sx={{
        width: "100%",
        // maxWidth: 700,
        borderRadius: 2,
        border: "1px solid rgba(221, 221, 221, 1)",
        boxShadow: 0,
        mt: 2
        // m: "auto",
      }}
    >
      {/* Collaboration Availability */}
      {/* Collaboration Availability */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          <Typography
            sx={{
              color: "var(--color-grey-6, rgba(15, 15, 15, 1))",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            Collaboration Availability
          </Typography>
          <Typography
            sx={{
              color: "var(--color-grey-38, rgba(96, 96, 96, 1))",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            Toggle whether you’re currently open to new collaboration requests.
          </Typography>
        </Box>
        <Form.Check
          type="switch"
          checked={collabAvailable}
          onChange={() => setCollabAvailable(!collabAvailable)}
        />
      </Box>
      <Divider
        sx={{ my: 3, height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }}
      />

      {/* Past Collaborations */}
      {/* Past Collaborations */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          <Typography
            sx={{
              color: "var(--color-grey-6, rgba(15, 15, 15, 1))",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            Past Collaborations
          </Typography>
          <Typography
            sx={{
              color: "var(--color-grey-38, rgba(96, 96, 96, 1))",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            Choose to display or hide your previous collaborations on your
            profile.
          </Typography>
        </Box>
        <Form.Check
          type="switch"
          checked={pastCollabVisible}
          onChange={() => setPastCollabVisible(!pastCollabVisible)}
        />
      </Box>

      <Divider
        sx={{ my: 3, height: 2, backgroundColor: "rgba(221, 221, 221, 1)" }}
      />
      {/* Blocked Users */}
      <Box>
        <Typography
          sx={{
            color: "var(--color-grey-6, rgba(15, 15, 15, 1))",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
          }}
          mb={1}
        >
          Blocked Users
        </Typography>
        <Typography
          sx={{
            color: "var(--color-grey-38, rgba(96, 96, 96, 1))",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
          }}
          mb={2}
        >
          Manage your blocked list. Users on this list won’t be able to view or
          interact with your profile.
        </Typography>

        {blockedUsers.map((user) => (
          <Paper
            key={user.id}
            elevation={1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              mt: 1,
              border: "1px solid rgba(221, 221, 221, 1)",
              boxShadow: 0,
            }}
          >
            <Box display="flex" alignItems="center">
              <Avatar
                src="https://randomuser.me/api/portraits/women/44.jpg"
                sx={{ mr: 2 }}
              />
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0",
                    verticalAlign: "middle",
                    color: "var(--color-grey-6, rgba(15, 15, 15, 1))",
                  }}
                >
                  {user.name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0",
                    verticalAlign: "middle",
                    color: "var(--color-grey-38, rgba(96, 96, 96, 1))",
                  }}
                >
                  Category: {user.category}
                </Typography>
              </Box>
            </Box>
            <Button
              disableRipple
              sx={{
                border: "none !important",
                boxShadow: "none !important",
                color: "rgba(107, 142, 118, 1)",
                textTransform: "none",
                fontWeight: 500,
              }}
            >
              Unblock
            </Button>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default PrivacyVisiblity;
